import api from './api';

export const partyService = {
  // Classifications
  getClassifications: async (params = {}) => {
    const response = await api.get('/parties/classifications', { params });
    return response.data;
  },

  // Parties
  getParties: async (params = {}) => {
    const response = await api.get('/parties', { params });
    return response.data;
  },

  getPartyById: async (id) => {
    const response = await api.get(`/parties/${id}`);
    return response.data;
  },

  createParty: async (data) => {
    const response = await api.post('/parties', data);
    return response.data;
  },

  updateParty: async (id, data) => {
    const response = await api.put(`/parties/${id}`, data);
    return response.data;
  },

  updatePartyStatus: async (id, isActive) => {
    const response = await api.patch(`/parties/${id}/status`, { isActive });
    return response.data;
  },

  // Contracts
  getContracts: async (params = {}) => {
    const response = await api.get('/contracts', { params });
    return response.data;
  },

  getContractById: async (id) => {
    const response = await api.get(`/contracts/${id}`);
    return response.data;
  },

  createContract: async (data) => {
    const response = await api.post('/contracts', data);
    return response.data;
  },

  updateContract: async (id, data) => {
    const response = await api.put(`/contracts/${id}`, data);
    return response.data;
  },

  updateContractStatus: async (id, isActive) => {
    const response = await api.patch(`/contracts/${id}/status`, { isActive });
    return response.data;
  },

  // Contract Items
  getContractItems: async (contractId, params = {}) => {
    const response = await api.get(`/contracts/${contractId}/items`, { params });
    return response.data;
  },

  addContractItem: async (contractId, data) => {
    const response = await api.post(`/contracts/${contractId}/items`, data);
    return response.data;
  },

  removeContractItem: async (itemId, remarks = null) => {
    const response = await api.delete(`/contracts/items/${itemId}`, { data: { remarks } });
    return response.data;
  },

  // Central Rate Resolution
  resolveRate: async (data) => {
    const response = await api.post('/rates/resolve', data);
    return response.data;
  },

  // Portal User Management
  getPortalUsers: async (partyId) => {
    const response = await api.get(`/parties/${partyId}/portal-users`);
    return response.data;
  },

  provisionPortalUser: async (partyId, data) => {
    const response = await api.post(`/parties/${partyId}/portal-users`, data);
    return response.data;
  },

  updatePortalUserStatus: async (userId, isActive) => {
    const response = await api.patch(`/parties/portal-users/${userId}/status`, { isActive });
    return response.data;
  },

  // Party Financial Ledger / Khata
  getPartyLedger: async (partyId, params = {}) => {
    const response = await api.get(`/parties/${partyId}/ledger`, { params });
    return response.data;
  },

  // Party Co-Branding Logo Upload
  uploadPartyLogo: async (partyId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`/parties/${partyId}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};

export default partyService;
